import React from 'react'
import ReactDOM from 'react-dom'

import { App } from './bootstrap/components'

import './index.css'

ReactDOM.render(<App />, document.getElementById('root'))
